import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "packages/libs/backend-utils/src/exception-handling/application-exception-handler";
import { RacksService } from "./rack.service";
import { RacksEntity } from "./rack.entity";
import { RacksController } from "./rack.controller";
import { RacksAdapter } from "./rack.adaptor";
import { EmployeeDetailsRepo } from "../employee-details/dto/employee-detail-repository";
import { EmplyeeDetails } from "../employee-details/dto/employee-details-entity";
import { EmployeeBuyerMappingService } from "../employee-buyer-mapping/employee-buyer-mapping.service";
import { EmployeeBuyerMappingRepository } from "../employee-buyer-mapping/employee-buyer-mapping.repo";
import { EmployeeBuyerMapping } from "../employee-buyer-mapping/employee-buyer-mapping.entity";


@Module({
    imports: [TypeOrmModule.forFeature([RacksEntity,EmplyeeDetails,EmployeeBuyerMapping])],
    controllers: [RacksController],
    providers: [RacksService, ApplicationExceptionHandler, RacksAdapter,EmplyeeDetails,EmployeeBuyerMappingService,EmployeeDetailsRepo,EmployeeBuyerMappingRepository],
    exports: [TypeOrmModule, RacksService]
})

export class RacksModule { }